import BOSFilterSelect from 'Components/Generic/BOSFilterSelect';
import { OBJECT_STATUS } from 'Data/Enum';
import ServiceContractData from 'Data/ServiceContractData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

let DM = new DataManager();
const ServiceContractSelect = ({
  orgId,
  defaultSelectedId,
  onSelectServiceContract,
  ...props
}) => {
  const [serviceContractList, setServiceContractList] = useState([]);

  useEffect(() => {
    DM.add(
      ServiceContractData.registerListener(
        'SC_LIST_FOR_CORE_LOADED',
        onServiceContractListLoaded,
      ),
      ServiceContractData,
    );
    DM.add(
      ServiceContractData.registerListener(
        'RECORDS_LOAD_ERROR',
        onServiceContractListLoadError,
      ),
      ServiceContractData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    ServiceContractData.getServiceContractsForOrg(orgId);
  }, [orgId]);

  const onServiceContractListLoaded = (payload) => {
    if (payload) {
      setServiceContractList(payload.records);
    }
  };

  const onServiceContractListLoadError = () => {};

  return (
    <BOSFilterSelect
      listData={serviceContractList}
      onItemSelect={onSelectServiceContract}
      defaultSelectedId={defaultSelectedId}
      labelFunction={(sc) =>
        sc?.status === OBJECT_STATUS.ACTIVE.key
          ? sc.name
          : `${sc.name} (Inactive)`
      }
      inactiveStyleFunction={(sc) => sc?.status !== OBJECT_STATUS.ACTIVE.key}
      {...props}
    />
  );
};

ServiceContractSelect.propTypes = {
  orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultSelectedId: PropTypes.number,
  onSelectServiceContract: PropTypes.func,
  isRequired: PropTypes.bool,
  onBlur: PropTypes.func,
};

export default ServiceContractSelect;
